import {
  createReactRouterV5Options,
  ErrorsInstrumentation,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from '@grafana/faro-react'
import { mapEnvToLogRocketEnv } from './sagas/userObject/logRocket'
import { history } from './routes/Routes'
import { Route } from 'react-router-dom'

initializeFaro({
  url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/c897ca062485618922de4556a1eef7ed',
  apiKey: 'c897ca062485618922de4556a1eef7ed',
  app: {
    name: 'BedBooking Web',
    version: process.env.REACT_APP_VERSION || 'unknow',
    environment: mapEnvToLogRocketEnv(process.env.REACT_APP_API_URL),
  },
  instrumentations: [
    ...getWebInstrumentations(),
    new ErrorsInstrumentation(),
    new ReactIntegration({
      router: createReactRouterV5Options({
        history: history as any, // the history object used by react-router
        Route, // Route component imported from react-router package
      }),
    }),
  ],
})
